import { computed, getCurrentInstance, onMounted, ref } from "vue";

import { useSearchStore, useUserStore } from "@/stores";

export function useCompanyDictionaryAd() {
  const userStore = useUserStore();
  const searchStore = useSearchStore();

  const dictionaryId = "ad-company-dictionary";
  const showAd = ref<boolean>(false);
  const isAdSelected = computed<boolean>(() => searchStore.selectedDictionaryId === dictionaryId);

  // Prevent running onMounted when search store is used in route guards
  if (getCurrentInstance()) {
    onMounted(async () => {
      const userData = await userStore.getUser();
      showAd.value = userData.featureFlags.showCompanyDictionaryAd;
    });
  }

  return {
    dictionaryId,
    showAd,
    isAdSelected
  };
}
